import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { environment } from 'environments/environment';

@Injectable()
export class SecuGenService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    patientFingerprint = (): Observable<any> => {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        return this._http.post<any>(`${environment.SecuGenUrl}`,`${environment.SecuGenBody}`, { headers });
    }
}
